import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobile(e.matches);
    };
    mql.addEventListener("change", onChange);
    // Use requestAnimationFrame to defer the initial read and avoid forced reflow
    requestAnimationFrame(() => {
      onChange(mql);
    });
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
